/* ComponentAppBanner template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { AppBannerComponent } from './cwc-app-banner';

/**
 * Definition of  parameters that the template needs to work.
 */
interface AppBannerTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: AppBannerComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const AppBannerTemplate: FunctionalComponent<AppBannerTemplateProps> = ({ controller }) => (
  <Host style={!controller.opened || !controller.isEnabled() ? { display: 'none' } : {}}>
    <cwc-app-banner-close onclick={() => controller.onClose()}>
      <slot name={'closingIcon'}>
        <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
      </slot>
    </cwc-app-banner-close>

    <cwc-app-banner-body>
      <cwc-app-banner-image>
        {controller.operatingSystem === 'ios' ? <slot name="appStoreImg" /> : ''}
        {controller.operatingSystem === 'android' ? <slot name="playStoreImg" /> : ''}
      </cwc-app-banner-image>

      <cwc-app-banner-text>
        <slot name="headline" />
        <slot name="subline" />
      </cwc-app-banner-text>
    </cwc-app-banner-body>

    <cwc-app-banner-view>
      <a href={controller.getStoreLink()} title={'App ' + controller.btnLabel} target="_blank">
        <cwc-app-banner-button onclick={() => controller.onView()}>{controller.btnLabel}</cwc-app-banner-button>
      </a>
    </cwc-app-banner-view>
  </Host>
);

export default AppBannerTemplate;
